import { cn } from "~/lib/utils";
import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { useTiers } from "~/api/swr/useTiers";
import { useCategories } from "~/api/swr/useCategories";
import { useState } from "react";
import { Popover, PopoverAnchor, PopoverContent } from "~/atoms/popover";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "~/atoms/dropdown-menu";
import { NewDocumentForm } from "./NewDocumentForm";
import { ChevronRight, File, Files } from "lucide-react";
import { useNavigate } from "react-router";

export function NewDocumentButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: tiers } = useTiers();
  const { data: categories } = useCategories();
  const [menuOpen, setMenuOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const open = menuOpen || formOpen;

  return (
    <Popover open={formOpen} onOpenChange={setFormOpen}>
      <DropdownMenu open={menuOpen} onOpenChange={setMenuOpen}>
        <PopoverAnchor asChild>
          <DropdownMenuTrigger asChild>
            <Button>
              {t(($) => $.commons.create.document)}
              <ChevronRight
                className={cn("transition-transform", open && "rotate-90")}
              />
            </Button>
          </DropdownMenuTrigger>
        </PopoverAnchor>
        <DropdownMenuContent align="start" className="w-80">
          <DropdownMenuItem
            onSelect={() => {
              setMenuOpen(false);
              setFormOpen(true);
            }}
            className="gap-3"
          >
            <File className="text-muted-foreground size-5" />
            <div className="flex flex-col">
              <span className="text-sm font-medium">
                {t(($) => $.commons.create.oneDocument.title)}
              </span>
              <span className="text-muted-foreground text-xs">
                {t(($) => $.commons.create.oneDocument.description)}
              </span>
            </div>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onSelect={() => void navigate("/onboarding/documents")}
            className="gap-3"
          >
            <Files className="text-muted-foreground size-5" />
            <div className="flex flex-1 flex-col">
              <span className="text-sm font-medium">
                {t(($) => $.commons.create.manyAtOnce.title)}
              </span>
              <span className="text-muted-foreground text-xs">
                {t(($) => $.commons.create.manyAtOnce.description)}
              </span>
            </div>
            <ChevronRight className="text-muted-foreground size-4" />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <PopoverContent
        className="w-[400px]"
        align="start"
        onFocusOutside={(e) => e.preventDefault()}
      >
        <NewDocumentForm categories={categories} tiers={tiers} />
      </PopoverContent>
    </Popover>
  );
}
